import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { formValueSelector } from 'redux-form';
import { toast } from 'react-toastify';

import { AssignWhKitToSiteAndSiteGroupContainer } from './containers/AssignSiteAndSiteGroupContainer';
import * as actions from './../state/assignorderpreference/actions';
import { LoadingPage, DirtyWrapper } from 'Components';
import { Filter, Main } from 'Containers';
import { errorToast, toastSuccess, toastError } from 'Common/ToastHelper';
import {
  getStorageLocationForCurrentSite,
  clearFilterErrorMsg,
} from 'State/filters/actions';
import { submitForm, resetForm } from 'State/forms/actions';
import { OrderPreferenceEnum } from 'Common/FieldEnum';
import { OrderPreferenceEnum as OrderPrefsEnum } from 'Common/Constants/Enumeration/OrderPreferenceEnum';
import { makeWarehouseSiteIdOptions } from 'Common/FormHelper';
import { ASSIGN_ORDER_PREFERENCE_FORM_NAME } from 'Common/FormEnum';
import { getIsDirty } from 'Common/Selectors/DirtySelector';

class AssignOrderPreferenceList extends Component {
  state = {
    selectedRowInfo: null,
    isGroupSelected: false,
    id: -1,
    expanded: {},
    isReadOnly: true,
    isResetForm: false,
  };
  componentDidMount() {
    this.props.getSiteGroupWithSitesAndWarehouse();
    this.props.getWarehouses();
    this.props.getStorageLocationForCurrentSite();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      clearErrorMsgs,
      clearFilterErrorMsg,
      submittingOrderPreferenceData,
    } = this.props;
    if (
      errorToast(
        this.props,
        prevProps,
        'fetchingSiteGroupWithSitesAndWHLoadingError'
      ) ||
      errorToast(this.props, prevProps, 'fetchingSiteGroupWHLoadingError') ||
      errorToast(this.props, prevProps, 'submittingOrderPreferenceLoadingError')
    ) {
      clearErrorMsgs();
    }
    if (errorToast(this.props, prevProps, 'storageLocationDataError')) {
      clearFilterErrorMsg();
    }
    if (submittingOrderPreferenceData && submittingOrderPreferenceData.Data) {
      toastSuccess(submittingOrderPreferenceData.Data);
      clearErrorMsgs();
    }
  }
  componentWillUnmount() {
    toast.dismiss();
  }

  setParentState = values => {
    this.setState(values);
  };
  onHandleSubmit = values => {
    const { saveSiteGroupWarehouse, saveSiteWarehouse } = this.props;
    const { selectedRowInfo, isGroupSelected, id } = this.state;
    const model = _.cloneDeep(selectedRowInfo);
    model[OrderPreferenceEnum.OrderPreferenceId] =
      values[OrderPreferenceEnum.OrderPreferenceId];
    model[OrderPreferenceEnum.Sites] = null;
    const warehousesAndKitchens = _.filter(
      values[OrderPreferenceEnum.WarehouseKitchen],
      item => item.WarehouseSiteId !== null
    );
    if (
      values[OrderPreferenceEnum.OrderPreferenceId] &&
      values[OrderPreferenceEnum.OrderPreferenceId] !==
        OrderPrefsEnum.vendorOnly &&
      warehousesAndKitchens.length === 0
    ) {
      toastError(
        'Please select order preference to Distributor Direct OR select a Warehouse/Kitchen to order from.'
      );
    } else if (
      warehousesAndKitchens &&
      _.uniqBy(warehousesAndKitchens, 'WarehouseSiteId').length !==
        warehousesAndKitchens.length
    ) {
      toastError('Please clear duplicate warehouses or kitchens.');
    } else {
      model[OrderPreferenceEnum.WarehouseKitchen] =
        warehousesAndKitchens && warehousesAndKitchens.length
          ? _.map(warehousesAndKitchens, obj => {
              const description = obj[OrderPreferenceEnum.Text]
                ? obj[OrderPreferenceEnum.Text].split(':')
                : [];
              return {
                Id: obj[OrderPreferenceEnum.WarehouseSiteId],
                Description:
                  description.length > 1 ? description[1].trim() : '',
              };
            })
          : [];
      model[OrderPreferenceEnum.StapleDetail] = {
        [OrderPreferenceEnum.StapleRoute]:
          values[OrderPreferenceEnum.StapleRoute],
        [OrderPreferenceEnum.StapleStorageLocationId]:
          values[OrderPreferenceEnum.StapleStorageLocationId],
        [OrderPreferenceEnum.StapleDayOfWeekId]:
          values[OrderPreferenceEnum.StapleDayOfWeekId],
      };
      this.setState({
        selectedRowInfo: model,
        isReadOnly: true,
      });
      id !== -1 &&
        (isGroupSelected
          ? saveSiteGroupWarehouse(model).then(() => {
              const {
                submittingOrderPreferenceLoadingError,
                getSiteGroupWithSitesAndWarehouse,
                clearSubmitError,
              } = this.props;
              !submittingOrderPreferenceLoadingError
                ? getSiteGroupWithSitesAndWarehouse()
                : clearSubmitError();
            })
          : saveSiteWarehouse(model).then(() => {
              const {
                submittingOrderPreferenceLoadingError,
                getSiteGroupWithSitesAndWarehouse,
                clearSubmitError,
              } = this.props;
              !submittingOrderPreferenceLoadingError
                ? getSiteGroupWithSitesAndWarehouse()
                : clearSubmitError();
            }));
    }
  };
  onSaveClick = () => {
    this.props.submitForm(ASSIGN_ORDER_PREFERENCE_FORM_NAME);
  };
  getMainProps = showDirtyConfirm => {
    const { id } = this.state;
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Save',
            onClick: this.onSaveClick,
            disabled: id === -1,
          },
          {
            content: 'Cancel',
            onClick: showDirtyConfirm,
            disabled: id === -1,
          },
        ],
        shown: true,
      },
    };
  };
  setExpandedState = expanded => {
    this.setState({ expanded });
  };
  resetForm = () => {
    this.setState({ isReadOnly: true }, () => {
      this.setFormValues(this.state.selectedRowInfo);
    });
  };
  setFormValues = values => {
    const { changeFormValue } = this.props;
    changeFormValue(
      OrderPreferenceEnum.WarehouseKitchen,
      makeWarehouseSiteIdOptions(
        values[OrderPreferenceEnum.WarehouseKitchen],
        true
      )
    );
    changeFormValue(
      OrderPreferenceEnum.OrderPreferenceId,
      values[OrderPreferenceEnum.OrderPreferenceId]
    );
    changeFormValue(
      OrderPreferenceEnum.StapleDayOfWeekId,
      values[OrderPreferenceEnum.StapleDetail][
        OrderPreferenceEnum.StapleDayOfWeekId
      ]
    );
    changeFormValue(
      OrderPreferenceEnum.StapleStorageLocationId,
      values[OrderPreferenceEnum.StapleDetail][
        OrderPreferenceEnum.StapleStorageLocationId
      ]
    );
    changeFormValue(
      OrderPreferenceEnum.StapleRoute,
      values[OrderPreferenceEnum.StapleDetail][OrderPreferenceEnum.StapleRoute]
    );
  };

  render() {
    const {
      fetchingSiteGroupWithSitesAndWHLoading,
      siteGroupWithSitesAndWHData,
      fetchingSiteGroupWHLoading,
      siteGroupWHData,
      storageLocationData,
      storageLocationDataLoading,
      submittingOrderPreferenceLoading,
    } = this.props;
    const { selectedRowInfo, isGroupSelected, id, isReadOnly } = this.state;
    return fetchingSiteGroupWithSitesAndWHLoading ||
      fetchingSiteGroupWHLoading ||
      storageLocationDataLoading ||
      submittingOrderPreferenceLoading ? (
      <LoadingPage
        message={submittingOrderPreferenceLoading ? 'Saving...' : 'Loading...'}
      />
    ) : (
      <Fragment>
        <Filter title={'Assign Order Preference - Site/Groups'} />
        <DirtyWrapper
          closeModalYesCallback={this.resetForm}
          isReadOnly={isReadOnly}
        >
          {showDirtyConfirm => (
            <Main
              {...this.getMainProps(showDirtyConfirm)}
              shouldNotUsePageWidth
            >
              <AssignWhKitToSiteAndSiteGroupContainer
                siteDataSource={siteGroupWithSitesAndWHData}
                loadingSites={fetchingSiteGroupWithSitesAndWHLoading}
                setParentState={this.setParentState}
                siteGroupWHData={siteGroupWHData}
                selectedRowInfo={selectedRowInfo}
                isGroupSelected={isGroupSelected}
                id={id}
                storageLocationData={storageLocationData}
                onSubmit={this.onHandleSubmit}
                expanded={this.state.expanded}
                setExpandedState={this.setExpandedState}
                setFormValues={this.setFormValues}
                isResetForm={this.state.isResetForm}
              />
            </Main>
          )}
        </DirtyWrapper>
      </Fragment>
    );
  }
}

const selector = formValueSelector(ASSIGN_ORDER_PREFERENCE_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  const {
    CommonState: { filters },
    UtilitiesState: { assignOrderPreference },
  } = state;
  ownProps.setPageLevelDirty(
    getIsDirty(ASSIGN_ORDER_PREFERENCE_FORM_NAME)(state)
  );

  const {
    fetchingSiteGroupWithSitesAndWHLoading,
    siteGroupWithSitesAndWHData,
    fetchingSiteGroupWithSitesAndWHLoadingError,
    fetchingSiteGroupWHLoading,
    siteGroupWHData,
    fetchingSiteGroupWHLoadingError,
    submittingOrderPreferenceLoadingError,
    submittingOrderPreferenceLoading,
    submittingOrderPreferenceData,
  } = assignOrderPreference;
  const {
    storageLocationData,
    storageLocationDataLoading,
    storageLocationDataError,
  } = filters;
  return {
    fetchingSiteGroupWithSitesAndWHLoading,
    siteGroupWithSitesAndWHData,
    fetchingSiteGroupWithSitesAndWHLoadingError,
    fetchingSiteGroupWHLoading,
    siteGroupWHData,
    fetchingSiteGroupWHLoadingError,
    storageLocationData,
    storageLocationDataLoading,
    storageLocationDataError,
    submittingOrderPreferenceLoadingError,
    submittingOrderPreferenceLoading,
    submittingOrderPreferenceData,
    warehouseKitchen: selector(state, OrderPreferenceEnum.WarehouseKitchen),
    orderPreferenceId: selector(state, OrderPreferenceEnum.OrderPreferenceId),
    stapleDayOfWeekId: selector(state, OrderPreferenceEnum.StapleDayOfWeekId),
    stapleStorageLocationId: selector(
      state,
      OrderPreferenceEnum.StapleStorageLocationId
    ),
    stapleRoute: selector(state, OrderPreferenceEnum.StapleRoute),
  };
};

export const AssignOrderPreference = connect(
  mapStateToProps,
  {
    ...actions,
    getStorageLocationForCurrentSite,
    clearFilterErrorMsg,
    submitForm,
    resetForm,
  }
)(AssignOrderPreferenceList);



// WEBPACK FOOTER //
// ./src/pages/utilities/assignorderpreference/AssignOrderPreferenceList.js